import { R2_UPLOADS_ENABLED } from '../lib/config';

export type UploadProviderPreference = 'ardrive' | 's3' | 'r2';

const PROVIDER_DISPLAY_NAMES: Record<UploadProviderPreference, string> = {
  ardrive: 'ArDrive',
  s3: 'AWS S3',
  r2: 'Cloudflare R2',
};

export function isUploadProviderEnabled(
  provider: UploadProviderPreference,
): boolean {
  return provider !== 'r2' || R2_UPLOADS_ENABLED;
}

export function getEnabledUploadProviders(): UploadProviderPreference[] {
  return (
    Object.keys(PROVIDER_DISPLAY_NAMES) as UploadProviderPreference[]
  ).filter(isUploadProviderEnabled);
}

export function providerRequiresWallet(
  provider: UploadProviderPreference,
): boolean {
  return provider !== 'r2';
}
